<template>
  <div class="c-content-details">
    <!-- heading -->
    <h2 v-if="heading" class="c-heading text-heading-3 text-left mb-4">
      {{ heading }}
    </h2>
    <div v-else class="c-titles">
      <h2 class="c-title text-heading-3">
        {{ title }}
      </h2>
      <h3 class="c-subtitle mt-2 text-heading-4">
        {{ subtitle }}
      </h3>
    </div>

    <div v-if="showThumbnail" class="c-thumbnail my-4">
      <v-img contain :src="item.thumbnail"></v-img>
    </div>

    <!-- description -->
    <RichText v-if="hasDescription" class="mt-2" :blocks="description" />

    <!-- tabs -->
    <RichTabs
      v-if="hasTabs"
      header-colour="background"
      tab-colour="sheet"
      :tabs="tabs"
    />
  </div>
</template>

<script>
import RichTabs from '@/components/base/RichTabs'
import RichText from '@/components/base/RichText'

export default {
  name: 'ContentDetails',

  components: {
    RichTabs,
    RichText
  },

  props: {
    item: {
      type: Object,
      required: true
    },

    body: {
      type: Array,
      required: false,
      default: () => []
    },

    showThumbnail: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    /* primary details */

    heading() {
      return this.item.details?.heading
    },

    description() {
      /* precendence:
        1. body prop (passed in)
        2. detailed description (from item.details)
        3. summary (from back of card)
      */
      return this.body.length > 0
        ? this.body
        : this.detailedDescription.length > 0
        ? this.detailedDescription
        : this.summary.length > 0
        ? this.summary
        : []
    },

    hasDescription() {
      return this.description.length > 0
    },

    detailedDescription() {
      return this.item.details?.description?.length > 0 ? this.item.details.description : []
    },

    summary() {
      return this.item.summary?.length > 0 ? this.item.summary : []
    },

    tabs() {
      return this.item.details?.tabs || []
    },

    hasTabs() {
      return this.tabs.length > 0
    },

    /* fallback details */

    title() {
      return this.item.title
    },

    subtitle() {
      return this.item.subtitle
    }
  }
}
</script>

<style lang="css" scoped>
.c-heading,
.c-titles {
  line-height: 1.2;
}
.c-thumbnail {
  max-width: 300px;
}
</style>
